import { t } from '@lingui/core/macro';
import { NoddiDialog, NoddiTabs, TabItem } from 'noddi-ui-web';
import { TireWearInfoContent } from 'noddi-web';
import { useState } from 'react';
import { getCommonTranslations, getTabsTranslations } from '../../utils/commonTranslations';

interface TireInformationDialogProps {
  open: boolean;
  onClose: () => void;
}

// Determine current season based on month (Northern Hemisphere)
const getCurrentSeason = (): 'winter' | 'summer' => {
  const month = new Date().getMonth() + 1; // 1-12
  // Winter: November (11) - March (3)
  // Summer: April (4) - October (10)
  return month >= 4 && month <= 10 ? 'summer' : 'winter';
};

type TireSeasonTab = 'winter' | 'summer';

export const TireInformationDialog = ({ open, onClose }: TireInformationDialogProps) => {
  const { soonWornOut, inAGoodCondition, wornOut } = getCommonTranslations().wheelMeasurements;
  const currentSeason = getCurrentSeason();
  const [selectedTab, setSelectedTab] = useState<TireSeasonTab>(currentSeason);

  const baseTranslations = {
    goodCondition: inAGoodCondition,
    shouldBeReplaced: soonWornOut,
    mustBeReplaced: wornOut,
    regulationsTitle: t`Regulations and our recommendations`
  };

  const tabItems: TabItem<TireSeasonTab>[] = [
    {
      label: getCommonTranslations().wheelMeasurements.winterTires,
      value: 'winter',
      node: (
        <TireWearInfoContent
          season='winter'
          translations={{
            ...baseTranslations,
            regulationsDescription: getCommonTranslations().winterTiresMinimumNotice
          }}
        />
      )
    },
    {
      label: getCommonTranslations().wheelMeasurements.summerTires,
      value: 'summer',
      node: (
        <TireWearInfoContent
          season='summer'
          translations={{
            ...baseTranslations,
            regulationsDescription: getCommonTranslations().summerTiresMinimumNotice
          }}
        />
      )
    }
  ];

  return (
    <NoddiDialog title={t`Tread depth`} open={open} onClose={onClose} maxWidth='md'>
      <NoddiTabs
        value={selectedTab}
        onValueChange={setSelectedTab}
        tabItems={tabItems}
        defaultValue={currentSeason}
        translations={getTabsTranslations()}
      />
    </NoddiDialog>
  );
};
